import React from "react";
import { Bot } from "lucide-react";
import type { MessageNode } from "./utils";
import { formatStepCount } from "./utils";
import { TIMELINE_RAIL_CLASS } from "./AgentWorkTimeline";
import { TimelineStepShell } from "./TimelineStepShell";

interface TimelineSubAgentStepProps {
  node: MessageNode;
  description?: string;
  stepCount: number;
  isExpanded: boolean;
  onToggle: () => void;
  isThreadActive: boolean;
  children: React.ReactNode;
}

/**
 * A sub-agent task as a timeline step: bot row with the agent's own
 * description of the task and a step count, expanding to an indented nested
 * timeline of the sub-agent's steps. The row is named for what it is rather
 * than the raw subagent_type, which is "general" on nearly every call.
 */
export function TimelineSubAgentStep({
  node,
  description,
  stepCount,
  isExpanded,
  onToggle,
  isThreadActive,
  children,
}: TimelineSubAgentStepProps) {
  return (
    <TimelineStepShell
      icon={Bot}
      iconClassName="text-purple-700 dark:text-purple-300"
      label={
        <span className="flex min-w-0 items-baseline gap-2">
          <span className="shrink-0 text-purple-700 dark:text-purple-300">
            Sub-agent
          </span>
          {description && (
            <span className="min-w-0 truncate text-xs text-muted-foreground">
              {description}
            </span>
          )}
        </span>
      }
      meta={
        stepCount > 0 ? (
          <span className="shrink-0 text-xs text-muted-foreground">
            {formatStepCount(stepCount)}
          </span>
        ) : undefined
      }
      isInProgress={isThreadActive && !node.toolResult}
      isExpanded={isExpanded}
      onToggle={onToggle}
    >
      <div className={TIMELINE_RAIL_CLASS}>{children}</div>
    </TimelineStepShell>
  );
}
